<div class="cash-flow-page-wrapper">
  @if (!isViewProject) {
    <app-general-header title="General Cashflow" [hideBorder]="true">
      <div class="header-inputs">
        <app-dropdown
          [multiple]="true"
          class="input"
          name="projects"
          [ngModel]="filters().projectIds"
          (ngModelChange)="onProjectChange($event)"
          [options]="projectOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Projects"
          label="Projects"
        >
        </app-dropdown>
        @if (this.user.isManager) {
          <app-dropdown
            [multiple]="true"
            class="input"
            name="properties"
            [(ngModel)]="filters().propertyIds"
            (ngModelChange)="onPropertyChange($event)"
            [options]="propertyOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Locations"
            label="Locations"
          ></app-dropdown>
        }
        <app-search-input
          (searchText)="onSearchTextChange($event)"
          class="input w-[300px]"
          placeholder="Search Projects..."
          label="Search Projects..."
        ></app-search-input>
      </div>
    </app-general-header>
  }

  @if (cashflowStatus() === CASHFLOW_STATUS.IDLE || cashflowStatus() === CASHFLOW_STATUS.LOADING) {
    <app-page-loading></app-page-loading>
  } @else {
    <div
      class="cashflow-scrollbar-wrapper"
      [ngClass]="{
        'is-view-project': isViewProject,
        'page-content': !isViewProject,
      }"
    >
      <ng-scrollbar appearance="native" orientation="horizontal" class="std-scrollbar cashflow-horizontal-scrollbar">
        <div class="cashflow-content">
          <div class="graph">
            <app-cash-flow-graph
              [cashflowData]="cashflowData()"
              [isLoading]="cashflowStatus() === CASHFLOW_STATUS.RELOADING"
            ></app-cash-flow-graph>

            <div class="graph-dropdowns">
              @if (user.isPremiumSP) {
                <app-dropdown
                  class="input bg-color-white"
                  name="cashflow-view"
                  [ngModel]="cashflowView()"
                  (ngModelChange)="onCashflowViewChange($event)"
                  [options]="cashflowViewOptions"
                ></app-dropdown>
              }
              <app-dropdown
                class="bg-color-white"
                name="fiscalYear"
                [scrollIntoView]="true"
                [ngModel]="filters().year"
                (ngModelChange)="onFiscalYearChange($event)"
                [options]="fiscalYears$ | async"
                optionLabel="label"
                optionValue="value"
              >
              </app-dropdown>
            </div>
          </div>
          <div class="cashflow-table">
            <app-cashflow-table
              [isLoading]="cashflowStatus() === CASHFLOW_STATUS.RELOADING"
              [isViewProject]="isViewProject"
              [cashflowData]="cashflowData()"
              [cashflowView]="cashflowView()"
            ></app-cashflow-table>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  }
</div>
